import { all } from "redux-saga/effects";
import Auth from "./Auth";
import { watchmanageRoleSaga } from "./manageRole";
import { watchManageUserSaga } from "./manageUser";
import { watchFeatureSaga } from "./feature";
import { watchPermissionSaga } from "./permissions";
import { watchSideMenuSaga } from "./getSideMenu";
import { watchPrivilegeSaga } from "./privilege";
import { watchSensorProductSaga } from "./sensorProduct";
import { watchSensorInstanceSaga } from "./sensorInstance";
import { watchSensorDataSaga } from "./sensorData";
import { watchSensorAnalyticsSaga } from "./sensorAnalytics";
import { watchCqrsDataSaga } from "./cqrsData";
import { watchNotificationsSaga } from "./notification";
import { watchClientSaga } from "./client";
import { watchTicketSaga } from "./ticket";
import { watchMasterConfigSaga } from "./masterConfig";
import { watchManageSubscribersSaga } from "./manageSubscriber";
import { watchServiceProviderSaga } from "./serviceProvider";
import { watchDocumentSaga } from "./document";
import { watchFeActivitySaga } from "./feActivity";
import { watchDeviceSaga } from "./device";
import { watchQuestionsSaga } from "./questions";
import { watchFireExtinguisherSaga } from "./fireExtinguisher";
import { watchLocationSaga } from "./location";
import { watchOrganizationSaga } from "./organization";
import { watchAssetTypeSaga } from "./assetType";
import { watchPlantSaga } from "./plant";
import { watchUnitSaga } from "./unit";
import { watchManageSiteSaga } from "./siteMange";
import { watchAssetSaga } from "./asset";
import { watchSystemTicketSaga } from "./systemTIcket";
import { watchSensorInstanceUnitSaga } from "./sensorInstanceUnit";
import { watchPreventiveMaintenanceSaga } from "./preventiveMaintenance";
import { watchPreSaleMaintenenceSaga } from "./preSaleMaintenence";
import { watchMachineSaga } from "./machine";
import { watchSparePartsSaga } from "./spareParts";
import { watchChecklistSaga } from "./checklist";
import { watchActionNoteSaga } from "./actionNote";
import { watchExpenseSaga } from "./expense";
import { watchSvcMachineTypeSaga } from "./svcMachineType";
import { watchSvcMachineInstanceSaga } from "./svcMachineInstance";
import { watchSparePartSaga } from "./manageSparePart";
import { watchDiscussionSaga } from "./discussion";
import { watchBreakdownMaintenanceSaga } from "./breakdownMaintenance";
import { watchInstallationCommissioningSaga } from "./installationCommissioning";
import { watchSvcExpenseSaga } from "./svcExpenseList";
import { watchFileUploadSaga } from "./fileUpload";
import { watchActionTicketSaga } from "./actionTicket";
import { watchMaintenanceClientSaga } from "./maintenanceClient";

export default function* rootSaga(getState) {
  yield all([
    Auth(),
    watchmanageRoleSaga(),
    watchManageUserSaga(),
    watchFeatureSaga(),
    watchPermissionSaga(),
    watchSideMenuSaga(),
    watchPrivilegeSaga(),
    watchSensorProductSaga(),
    watchSensorInstanceSaga(),
    watchSensorDataSaga(),
    watchSensorAnalyticsSaga(),
    watchCqrsDataSaga(),
    watchNotificationsSaga(),
    watchClientSaga(),
    watchTicketSaga(),
    watchMasterConfigSaga(),
    watchManageSubscribersSaga(),
    watchServiceProviderSaga(),
    watchDocumentSaga(),
    watchFeActivitySaga(),
    watchDeviceSaga(),
    watchQuestionsSaga(),
    watchFireExtinguisherSaga(),
    watchLocationSaga(),
    watchOrganizationSaga(),
    watchAssetTypeSaga(),
    watchPlantSaga(),
    watchUnitSaga(),
    watchManageSiteSaga(),
    watchAssetSaga(),
    watchSystemTicketSaga(),
    watchSensorInstanceUnitSaga(),
    watchPreventiveMaintenanceSaga(),
    watchPreSaleMaintenenceSaga(),
    watchMachineSaga(),
    watchSparePartsSaga(),
    watchChecklistSaga(),
    watchActionNoteSaga(),
    watchExpenseSaga(),
    watchSvcMachineTypeSaga(),
    watchSvcMachineInstanceSaga(),
    watchSparePartSaga(),
    watchDiscussionSaga(),
    watchBreakdownMaintenanceSaga(),
    watchInstallationCommissioningSaga(),
    watchSvcExpenseSaga(),
    watchFileUploadSaga(),
    watchActionTicketSaga(),
    watchMaintenanceClientSaga()
  ]);
}
